<template>
  <v-data-table
    class="no-border"
    :items="getRecentPreparationSlips"
    :items-per-page="10"
    dense
    hide-default-footer
    hide-default-header
    :mobile-breakpoint="0"
    :headers="headers"
    sort-by="date"
    :sort-desc="true"
    :loading="loading"
  >
    <template v-slot:item="{ item }">
      <tr>
        <td width="140">
          <span class="caption">{{ formatDate(item) }}</span>
        </td>
        <td>
          <span class="caption" style="text-transform: capitalize;">{{
            getTemplateName(item)
          }}</span>
        </td>
        <td>
          <v-row align="center" justify="end" no-gutters>
            <v-btn
              icon
              small
              @click="
                $router.push({
                  name: 'PreparationSlipViewer',
                  params: { id: item.id }
                })
              "
            >
              <v-icon small>fa-external-link-alt</v-icon>
            </v-btn>
          </v-row>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "ProductionGrid",
  props: {
    loading: {
      default: false
    }
  },
  computed: {
    ...mapGetters([
      "getPreparationSlips",
      "getPreparationSlipTemplates",
      "getIsAdmin"
    ]),
    getRecentPreparationSlips() {
      const yesterday = moment().subtract(1, "d");
      return this.getPreparationSlips.filter(x =>
        moment(x.created).isSameOrAfter(yesterday)
      );
    }
  },
  data() {
    return {
      headers: [{ value: "date" }, { value: "name" }, { value: "actions" }]
    };
  },
  methods: {
    formatDate(item) {
      const d = moment(item.date);
      let time = "";
      if (d.hour() === 12) {
        time = "Midi";
      } else if (d.hour() === 18) {
        time = "Soir";
      } else {
        time = "Matin";
      }
      return `${d.format("LL")} ${time}`;
    },
    getTemplateName(item) {
      const t = this.getPreparationSlipTemplates.find(
        x => x.id === item.fk_preparation_slip_template
      );
      return t !== undefined ? t.name : "";
    }
  }
};
</script>

<style></style>
